var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border"},[_c('div',{staticStyle:{"padding":"1rem"}},[_c('PageHeader',{attrs:{"title":"รายละเอียดผู้เรียนในคอร์ส"}}),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('courseIntructor',{attrs:{"apiRoute":`/v1/analytics/courses/getCourseForIntructors`,"perPage":20}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }